import { InstitutionOnboardingProgressStep } from '@/context/progress';
import ServicesAgreement from '@/features/services-agreement/components/agreement';
import VerificationLayout from '@/features/verification/layout';

const InstitutionOnboardingServicesAgreementPage = () => {
  return (
    <VerificationLayout currentStep={InstitutionOnboardingProgressStep.INSTITUTION_VERIFICATION} fill>
      <ServicesAgreement next="/institution/onboarding/verification" />
    </VerificationLayout>
  );
};
InstitutionOnboardingServicesAgreementPage.displayName = 'InstitutionOnboardingServicesAgreementPage';

export default InstitutionOnboardingServicesAgreementPage;
